<template>
  <v-app anchor-root
    v-resize="onWindowResize"
    :device="device">

    <!--Layout-->
    <router-view
    ></router-view>

    <appExtra
      v-if="applicationLoaded"
    ></appExtra>

  </v-app>
</template>

<script>
import Vue from 'vue'
import tracking from 'libs/tracking.js'
Vue.prototype.$tracking = tracking
import appExtra from 'appExtra/appExtra.vue'
import base from 'app/base.js'
import application from 'app/application.js'
export default {
  name: 'App',
  mixins: [base, application],
  created() {
    this.applicationCreated()
    this.baseAppCreated()
  },
  mounted() {
    this.baseAppMounted()
  },
  methods: {
    goTop() {
      this.$nextTick(() => {
        this.$vuetify.goTo(0)
      })
    },
  },
  components: {
    appExtra,
  },
  watch: {
    $route: {
      deep: true,
      handler(after, before) {
        if(after.name != before.name) return this.goTop()
        if(_isEqual(after.params, before.params) === false) return this.goTop()
        if(_isEqual(after.query, before.query) === false) return this.goTop()
      },
    }
  },
}
</script>

<style src="prismjs/themes/prism.css"></style>
<style src="viewerjs/dist/viewer.css"></style>
<style lang="sass" type="text/sass">
@media print
  *[anchor-layout]
    padding-left: 0 !important
</style>